import * as React from "react";
import { Dispatch } from "redux";
import { Item } from "../model/search-base-model";
import { setList, setCurrentList } from "../slice/search-slice";
import { getStaticItems } from "../factories/item-factory";
import ItemCard from "../components/item";
import { getMenuItems } from "../factories/menu-factory";
import MenuItemCard from "../menu-app/component/menu-item";

export const renderItem = (item: Item) => {
  return <ItemCard item={item} />;
};

export const initializeData = (dispatch: Dispatch<any>) => {
  const initialItems = getStaticItems();
  dispatch(setList(initialItems));
  dispatch(setCurrentList(initialItems));
};



export const renderMenuItem = (item: Item) => {
  return <MenuItemCard item={item} />;
};

export const initializeMenuData = (dispatch: Dispatch<any>) => {
  const initialItems = getMenuItems();
  dispatch(setList(initialItems));
  dispatch(setCurrentList(initialItems));
};
